import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { ResetPasswordAction, SetAuthLoading } from '../store/auth.actions';
import { ActivatedRoute } from '@angular/router';
import { BASE_URL } from 'src/environments/environment';
import { matchValidator, passwordValidator } from 'src/app/shared/validators/fields-validators';
import { FormFieldComponent } from 'src/app/shared/ui/form-field/form-field.component';
import { ButtonComponent } from 'src/app/shared/ui/button/button.component';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  imports: [ReactiveFormsModule, FormFieldComponent, ButtonComponent, TranslatePipe],
})
export class ResetPasswordComponent implements OnInit {
  private fb = inject(FormBuilder);
  private store = inject<Store<AppState>>(Store);
  private translateService = inject(TranslateService);
  private activateRoute = inject(ActivatedRoute);

  newPasswordForm!: FormGroup;
  isDropdownOpen = false;
  currentLanguage = '';
  currentYear: number = new Date().getFullYear();
  token!: string;
  BASE_URL = BASE_URL;

  ngOnInit(): void {
    localStorage.removeItem('currentUser');
    this.newPasswordForm = this.fb.group(
      {
        new_password: ['', [Validators.required, passwordValidator()]],
        confirm_password: ['', [Validators.required]],
      },
      { validator: matchValidator('new_password', 'confirm_password') }
    );

    const savedLang = localStorage.getItem('lang') || 'en';
    this.translateService.use(savedLang);
    this.currentLanguage = savedLang;

    this.token = this.activateRoute.snapshot.paramMap.get('token')!;
  }

  switchLanguage(lang: string) {
    if (lang !== this.translateService.getCurrentLang()) {
      this.translateService.use(lang);
    }
    localStorage.setItem('lang', lang);
    this.currentLanguage = lang;
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  passwordMatcher(formGroup: FormGroup) {
    const newPassword = formGroup.get('new_password')?.value;
    const confirmPassword = formGroup.get('confirm_password')?.value;
    if (newPassword && confirmPassword && newPassword !== confirmPassword) {
      formGroup.get('confirm_password')?.setErrors({ mismatch: true });
    } else {
      formGroup.get('confirm_password')?.setErrors(null);
    }
  }

  resetPassword(): boolean {
    if (!this.newPasswordForm.valid) {
      this.newPasswordForm.markAllAsTouched();
      return false;
    }

    const { new_password, confirm_password } = this.newPasswordForm.value;
    this.store.dispatch(SetAuthLoading({ isLoading: true }));

    this.store.dispatch(
      ResetPasswordAction({
        payload: {
          newPassword: new_password,
          confirm_password,
          token: this.token,
        },
      })
    );

    return true;
  }
}
